import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  SectionTitle,
  Showcase,
  Header,
  Note,
  Intro,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        complete={true}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            A button group is a type of form input that presents selectable
            options as buttons. Use as an alternative to{' '}
            <Link
              class="link"
              to={'/' + data.site + '/components/radio/design'}
            >
              radio
            </Link>{' '}
            or{' '}
            <Link
              class="link"
              to={'/' + data.site + '/components/select/design'}
            >
              select
            </Link>{' '}
            components with no more than four options. Each option shares the
            same container and text label structure as a standard button.
          </p>
        </Intro>
        <SectionTitle>Variants</SectionTitle>
        <Showcase
          site={data.site}
          text="Every button group displays both active and inactive options, indicated primarily by the fill color of the container. All options are inactive to start, and the user can only select one active option at a time. Active and inactive options each have three states: default, hover, and focus."
        >
          <div
            class="c-button-group"
            role="group"
            aria-label="Button Group Example"
          >
            <button type="button" class="c-button-group__button--active">
              Left
            </button>
            <button type="button" class="c-button-group__button">
              Middle
            </button>
            <button type="button" class="c-button-group__button">
              Right
            </button>
          </div>
        </Showcase>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Use this component in forms when there are at least two and no more
          than four options to choose from. Individual buttons within the group
          will be divided evenly across the full width of the component. Keep
          button groups at a distance of 32px from the previous component.
        </p>
        <Showcase
          site={data.site}
          text={
            <Note>
              If it’s not possible to meet all of these guidelines, use the{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/radio/design'}
              >
                radio
              </Link>{' '}
              component instead.
            </Note>
          }
        >
          <div
            class="c-button-group l-margin-bottom--large"
            role="group"
            aria-label="Button Group Example"
          >
            <button type="button" class="c-button-group__button--active">
              One
            </button>
            <button type="button" class="c-button-group__button">
              Two
            </button>
          </div>
          <div
            class="c-button-group"
            role="group"
            aria-label="Button Group Example"
          >
            <button type="button" class="c-button-group__button--active">
              One
            </button>
            <button type="button" class="c-button-group__button">
              Two
            </button>
            <button type="button" class="c-button-group__button">
              Three
            </button>
            <button type="button" class="c-button-group__button">
              Four
            </button>
          </div>
        </Showcase>
        <hr />
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Keep text labels on a single line and of similar length by removing
          unnecessary words. All options should use the same part of speech
          (e.g. all nouns or all verbs) rather than mixing. Use sentence case
          with no end punctuation.
        </p>
        <Note>
          If limiting wording this way sounds awkward, use the{' '}
          <Link class="link" to={'/' + data.site + '/components/radio/design'}>
            radio
          </Link>{' '}
          component instead.
        </Note>
      </Layout>
    </>
  )
}

export const code = {
  /*
  buttonGroup: `<div class="c-button-group" role="group" aria-label="Button Group Example">
  <button type="button" class="c-button-group__button--active">
    Button 1
  </button>
  <button type="button" class="c-button-group__button">
    Button 2
  </button>
  <button type="button" class="c-button-group__button">
    Button 3
  </button>
</div>
`,
*/
}
